import { useState, useCallback } from 'react';
import { modifyMeter } from '../services/meter.api';

export function useModifyMeter() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = useCallback(async (args) => {
    setLoading(true);
    setError(null);
    try {
      return await modifyMeter({
        reqType: args.reqType,
        oldMeter: args.oldMeter,
        oldFromDate: args.oldFromDate,
        newMeter: args.newMeter,
        selectedDate: args.selectedDate,
        comments: args.comments ?? null,
        faulty: !!args.faulty,
        user: args.user,
        filename: args.filename,
      });
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { mutate, loading, error };
}

export function useUpdateMeterFaulty() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = useCallback(async (args) => {
    setLoading(true);
    setError(null);
    try {
      return await modifyMeter({
        reqType: args.reqType,
        oldMeter: args.meterNumber,
        newMeter: args.meterNumber,
        oldFromDate: args.oldFromDate,
        selectedDate: args.selectedDate,
        comments: args.comments ?? null,
        faulty: !!args.faulty,
        user: args.user,
        filename: args.filename,
      });
    } catch (e) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { mutate, loading, error };
}
